export const PROFILE_BLOCKS = [
  // Låsta block
  { id: 'personal', label: 'Personuppgifter', icon: '📸', locked: true, defaultVisible: true },
  { id: 'ingress', label: 'Ingress', icon: '📝', locked: true, defaultVisible: true },
  
  // Flexibla block
  { id: 'competencies', label: 'Kompetensområden', icon: '🏆', locked: false, defaultVisible: true },
  { id: 'assignments', label: 'Uppdragserfarenhet i urval', icon: '💼', locked: false, defaultVisible: true },
  { id: 'employment', label: 'Anställningar', icon: '🏢', locked: false, defaultVisible: true },
  { id: 'education', label: 'Utbildning', icon: '🎓', locked: false, defaultVisible: true },
  { id: 'certifications', label: 'Certifieringar & Övrig utbildning', icon: '📚', locked: false, defaultVisible: true },
  { id: 'tools', label: 'IT & Verktyg', icon: '💻', locked: false, defaultVisible: true },
  { id: 'languages', label: 'Språk', icon: '🌍', locked: false, defaultVisible: true },
  { id: 'standards', label: 'Standarder & Regelverk', icon: '📋', locked: false, defaultVisible: true },
  { id: 'personal_profile', label: 'Personlig profil', icon: '🤝', locked: false, defaultVisible: true },
  { id: 'industries', label: 'Branscherfarenhet', icon: '🏭', locked: false, defaultVisible: true },

  // Valbara block
  { id: 'project_scale', label: 'Projektomfattning', icon: '📊', locked: false, defaultVisible: false },
  { id: 'publications', label: 'Publikationer & Föredrag', icon: '🎤', locked: false, defaultVisible: false },
  { id: 'references', label: 'Referenspersoner', icon: '👥', locked: false, defaultVisible: false },
  { id: 'licenses', label: 'Licenser', icon: '🚗', locked: false, defaultVisible: false },
  { id: 'board', label: 'Förtroendeuppdrag', icon: '🤝', locked: false, defaultVisible: false },
];

export const EXPERIENCE_FIRST_ORDER = [
  'personal', 'ingress', 'competencies', 'personal_profile', 'industries',
  'assignments', 'employment', 'education', 'certifications',
  'tools', 'standards', 'languages',
  'project_scale', 'publications', 'references', 'licenses', 'board'
];

export const ACADEMIC_FIRST_ORDER = [
  'personal', 'ingress', 'competencies', 'personal_profile',
  'education', 'certifications', 'industries',
  'assignments', 'employment',
  'tools', 'standards', 'languages',
  'project_scale', 'publications', 'references', 'licenses', 'board'
];